var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.logoPath)?_c('img',{attrs:{"src":_vm.logoPath}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }